<template>
    <div class="card">
        <div class="container-fluid mt-3 mb-3">
            <button  type="button" v-if="permission.citizen_create" @click="openModal" class="btn btn-primary pull-left"><i class="icons icon-user-follow"></i> সিটিজেন যুক্ত করুন</button>
            <a class="btn btn-info pull-right ml-2" href="/dashboard"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
            <form class="form-inline pull-right ">
                <input style="border-right:0;border-radius:5px 0 0 5px" v-model="search.search" class="form-control" type="search" placeholder="Name/Phone/NID" aria-label="Search">
                <button @click.prevent="searchContact" class="search"><i class="fa fa-search" aria-hidden="true"></i></button>
            </form>
        </div>
        <div class="container-fluid" style="overflow: auto;">
            <table id="my-table" class="table table-striped table_fields">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Phone</th>
                    <th scope="col">NID</th>
                    <th scope="col">Updated at</th>
                    <th scope="col">Updated by</th>
                    <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(contact,index) in allPContacts.data" :key="index" >
                        <td>{{index+1}}</td>
                        <td>{{contact.name}}</td>
                        <td>{{contact.mobile_number}}</td>
                        <td>{{contact.nid.substr(0, 17)}}</td>
                        <td>{{contact.updated_at}}</td>
                        <td>{{contact.updated_by}}</td>
                        <td>
                            <i v-if="permission.citizen_update || permission.citizen_update_all" @click="openEditModal(contact,index)" class="icon-note icons actn"> </i>
                            <!-- <router-link  :to="{ name : 'ContactDetails', params: {id : contact.id}}" style="padding:5px">
                            <i  class="icon-eye icons   actn"> </i>
                            </router-link> -->
                            <!-- <i  @click="deleteContact(index,contact.id)" class="icon-trash icons   actn"> </i> -->
                        </td>
                    </tr>
                </tbody>
            </table>
            <nav v-if="loading==false" aria-label="Page navigation example">
                <pagination :limit="5" :data="allPContacts" @pagination-change-page="getResults"></pagination>
            </nav>

            <AddContactModal ref="add_contact_modal"></AddContactModal>
            <EditContactModal :list='list' ref="edit_contact_modal"></EditContactModal>
            <ViewContactModal ref="view_contact_modal"></ViewContactModal>
            <Loader v-if="loading"></Loader>
        </div>
        <!-- <router-view></router-view> -->
    </div>
</template>
<script>

import pagination from 'laravel-vue-pagination'
import Vue from "vue";
import axios from "axios"
import AddContactModal from './AddContactModal'
import EditContactModal from './EditContactModal'
import ViewContactModal from './ViewContactModal'
import Loader from '../common/Loader'


import { ALL_CONTACT,ALL_P_CONTACT,DELETE_CONTACT,SEARCH_CONTACT,ALL_USER_ROLE2 } from "../../store/action.type"
import { mapState,mapGetters } from "vuex"
export default {
    data(){
        return {
            list:{},
            index2:0,
            largeModal2: false,
            contacts:[],
            permission:'',
            loading:false,
            search:{
                search:'',
                type:2
            }
        }
    },
    methods:{
        indexf(index){
            return this.index2+index;
        },
        deleteContact(index,id){
            var self = this
            this.$iziToast.question({
                timeout: 10000,
                close: false,
                overlay: true,
                displayMode: 'once',
                id: 'question',
                zindex: 999,
                title: 'Hey',
                message: 'Are you sure To Delete?',
                position: 'center',
                buttons: [
                    ['<button><b>YES</b></button>', function (instance, toast) {
                        self.$store.dispatch('DELETE_CONTACT',{index,id})
                        .then(response=>{
                            self.$iziToast.success({position:'topRight',title:'Ok',message:"Contact Delated Successsfully"})
                        })
                        .catch(error=>{
                            self.$iziToast.error({position:'topRight',title:'Error',message:"Something Wrong !!"})
                        });
                        instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');

                    }, true],
                    ['<button>NO</button>', function (instance, toast) {

                        instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');

                    }],
                ]
            });

        },
        viewContact(contact){
             this.$refs.view_contact_modal.openModal(contact)
        },
        openModal(){
            this.$refs.add_contact_modal.openModal()
        },
        openEditModal(contactdd,index){
            // console.log(contact)
            var contact2 = Object.assign({}, contactdd);
            this.$refs.add_contact_modal.openEditModal(contact2,index)
        },
        getResults(page = 1) {
            this.loading=true;
            var data = this.search
            this.$store.dispatch('ALL_P_CONTACT',{page,data})
            .then(response=>{
                this.loading=false;
            })
            .catch(error=>{
                this.loading=false;
            });
        },
        searchContact(){
            this.loading = true;
            var data = this.search
            var page = 1
            this.$store.dispatch('SEARCH_CONTACT',{page,data})
            .then(response=>{
                this.loading=false;
            })
            .catch(error=>{
                this.loading=false;
            });

        },
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        getPermission(){
            this.$store.dispatch('ALL_USER_ROLE2')
            .then(response=>{
                this.permission = response.data.permission
            })
        }
    },
    mounted(){
        this.getResults()
        this.allRole()
        this.getPermission()
    },
    computed: {
        ...mapGetters(["allPContacts","user_roles"]),
    },
    components: {
        AddContactModal,
        EditContactModal,
        ViewContactModal,
        Loader,
        pagination,
    }

}
</script>

<style>
.breadcrumb{
    margin-bottom: 1rem;
}
.search{
    border: 1px solid #e3dddd;
    padding: 5.25px 12px;
    background: transparent;
    border-radius: 0px 5px 5px 0px;
    border-left: 0;
    color: #888;
}
.main .container-fluid{
    padding: 0 16px;
}
.table_fields td {
    /* text-align: center; */
    border-bottom: 1px solid #dce1e9;
    border-right: 1px solid #dce1e9;
    font-size: 13px;
    line-height: 16px;
    color: #666;
    white-space:nowrap;
}
.table_fields th {
    /* text-align: center; */
    border-bottom: 1px solid #dce1e9;
    border-right: 1px solid #dce1e9;
    font-size: 13px;
    line-height: 16px;
    color: #666;
    white-space:nowrap;
}
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
 .table-area {
  position: relative;
  z-index: 0;
  margin-top: 50px;
}
.btn-info{ color: #fff; text-transform: capitalize; height: 35px; line-height: 35px; padding: 0rem 0.75rem;}

table.body {
  /* display: table; */
  /* required for table-layout to be used (not normally necessary; included for completeness) */
  /* table-layout: fixed; */
  /* this keeps your columns with fixed with exactly the right width */
  /* width: 100%; */
  /* table must have width set for fixed layout to work as expected */
  /* height: 100%; */
}

/* table.table_fields thead {
  position: fixed;
    top: 99px;
    left: 255px;
    right: 1px;
    width: 77%;
    height: 10px;
    line-height: 3em;
    background: #eee;
    table-layout: fixed;
    display: table;
}

table.table_fields th {
  background: #eee;
} */

/* table.table_fields td {
  line-height: 2em;
} */


</style>
<style scoped>
    @media (max-width: 575px){
        .form-control{ width: auto;}
        .btn{ margin-bottom: 10px;}
    }
</style>
